import request from "@/utils/request";

export function programGet(params) {
    return request({
        url: "/api/services/app/Program/Get",
        method: "GET",
        params
    });
}

export function programGetAllForDropdown(params) {
    return request({
        url: "/api/services/app/Program/GetAllForDropdown",
        method: "GET",
        params
    });
}

export function programCreate(data) {
    return request({
        url: "/api/services/app/Program/Create",
        method: "POST",
        data
    });
}

export function programUpdate(data) {
    return request({
        url: "/api/services/app/Program/Update",
        method: "PUT",
        data
    });
}

export function programDelete(params) {
    return request({
        url: "/api/services/app/Program/Delete",
        method: "DELETE",
        params
    });
}



// WEBPACK FOOTER //
// ./src/api/program.js